import React from 'react';
import { MapPin, ListChecks, Ruler, Truck } from 'lucide-react';
import { howItWorks } from '../../mock';

const iconMap = { MapPin, ListChecks, Ruler, Truck };

export default function HowItWorks() {
  return (
    <section id="how" className="py-16 md:py-24 bg-gradient-to-b from-white to-pink-50/40">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="zp-section-title">
            How <span className="zp-gradient-text">Zoopers</span> Works
          </h2>
          <p className="mt-4 text-slate-600 leading-relaxed">
            From doorstep pickup to expert stitching and quick delivery, we handle it all. Zoopers brings professional clothing services to your home — fast and seamless.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {howItWorks.map((step, i) => {
            const Icon = iconMap[step.icon] || MapPin;
            return (
              <div key={step.title} className="zp-card p-6 flex flex-col items-center text-center relative group">
                <div className="absolute -top-3 -right-3 h-8 w-8 rounded-full bg-[#E91E80] text-white text-xs font-bold grid place-items-center shadow-md">
                  {i + 1}
                </div>
                <div className="h-14 w-14 rounded-2xl bg-pink-50 text-[#E91E80] grid place-items-center mb-4 group-hover:scale-110 transition-transform">
                  <Icon size={26} />
                </div>
                <div className="text-lg font-bold text-slate-900">{step.title}</div>
                <div className="mt-1.5 text-sm text-slate-500">{step.desc}</div>
                {i < howItWorks.length - 1 && (
                  <div className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 w-6 h-0.5 border-t-2 border-dashed border-[#E91E80] opacity-60 z-10" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
